import { FormErrors } from 'redux-form'
import i18next from 'i18next'

export default (values: any) => {
	const errors: FormErrors<any> = {}
	const priority = Number(values.priority)

	if (priority < 0) {
		errors.priority = i18next.t('loc:Priority must be integer') as string
	}
	return errors
}
